import { combineReducers } from 'redux';
import { getSheetsDetails } from 'store/components/sheetDetails/sheetDetailsActions';
import { isLoadingReducer } from 'store/reducerUtils';

const loading = isLoadingReducer(getSheetsDetails);

export const sheetDetails = combineReducers({
    loading,
});
